/**
 * Matomo, the Foundation's own instance at allianz-foundation.de — the same
 * tracker the legacy sites used (gatsby-plugin-matomo on the old front end:
 * siteId 1 for allianzfoundation.org, 3 for next-generations-study.com,
 * cookieless, Do-Not-Track respected). Added on launch day 2026-10-06 so the
 * statistics do not stop at the switch.
 *
 * Hand-rolled rather than the plugin: the plugin is not in this monorepo's
 * lockfile and a dependency change the morning of a launch is the wrong trade.
 * The snippet below is the plugin's output, byte for byte where it matters
 * (`disableCookies`, `enableHeartBeatTimer`, DNT check, async loader).
 *
 * Tracks ONLY production builds (`GATSBY_ROBOTS_ENV=production`), so staging,
 * deploy previews and local builds send nothing. Page views are pushed from
 * gatsby-browser's onRouteUpdate, once per route (including the first), which
 * is why the head snippet itself does not call trackPageView.
 */

export const MATOMO_URL = 'https://allianz-foundation.de/';

/** One Strapi, three front-ends: the site id follows the SITE build flag. */
export const MATOMO_SITE_ID = process.env.SITE === 'ngs' ? '3' : '1';

export const MATOMO_ENABLED = process.env.GATSBY_ROBOTS_ENV === 'production';

/** The inline head script: configuration + async loader, no page view yet. */
export const matomoHeadScript = (): string => `
window._paq = window._paq || [];
if (!(navigator.doNotTrack === '1' || window.doNotTrack === '1')) {
  window._paq.push(['disableCookies']);
  window._paq.push(['setTrackerUrl', '${MATOMO_URL}matomo.php']);
  window._paq.push(['setSiteId', '${MATOMO_SITE_ID}']);
  window._paq.push(['enableHeartBeatTimer']);
  (function () {
    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.async = true; g.defer = true; g.src = '${MATOMO_URL}matomo.js';
    s.parentNode.insertBefore(g, s);
  })();
}
`.trim();
